import React from "react";
import styles from "./fix-pager-message.module.scss";
import { useTranslation } from "react-i18next";
import { PaginationMaxPages } from "@/util/constants";

export interface FixPagerMessageProps {
    current: number;
    totalItems: number;
    className?: string;
    size?: number;
}

export const FixPagerMessage: React.FC<FixPagerMessageProps> = ({
                                                                    current,
                                                                    totalItems,
                                                                    className,
                                                                    size = 20,
                                                                }) => {
    const { t } = useTranslation();

    const page = Math.max(1, Math.floor(Number(current)));
    const pageSize = Math.max(1, Math.floor(Number(size)));

    const visibleTotal = Math.min(totalItems, PaginationMaxPages * pageSize);
    const start = Math.min(visibleTotal, (page - 1) * pageSize + 1);
    const end = Math.min(visibleTotal, page * pageSize);

    return (
        <div className={className || styles.message}>
            {t("285l1mc8slbric5o.showing-products-size", {
                defaultValue: "Showing {{current}}–{{total}} of {{totalItems}} products",
                current: formatSpaces(start),
                total: formatSpaces(end),
                totalItems: formatSpaces(visibleTotal),
            })}
        </div>
    );
};

function formatSpaces(number: number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export default FixPagerMessage;